
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { environment } from 'projects/environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class NgbStringAdapter extends NgbDateAdapter<string> {

    fromModel(date: string): NgbDateStruct {
        // console.log('fromModel input ', date);
        if (date && date !== '') {
            // console.log('fromModel date isnull ? ', date);
            let dt = new Date(date);
            // console.log(dt);
            return {
                year: dt.getFullYear(),
                month: dt.getMonth() + 1,
                day: dt.getDate()
            }
        }
        else
        {
            return null;
        }
    }

    toModel(date: NgbDateStruct): string {
        //console.log('toModel input ', date);
        //return date ? new Date(date.year, date.month - 1, date.day) : null;
        let stringDate: string = "";
        if (date) {
            let datePipe = new DatePipe('en-US');
            stringDate = datePipe.transform(new Date(date.year, date.month -1, date.day), environment.DateFormat);
        }
        //console.log('toModel output ', stringDate);
        return stringDate;
    }
}